import { FC } from 'react';

import { Row } from 'antd';
import { useAppSelector } from 'hooks/redux';
import { getText } from 'utils/stringUtil';
import {
  ITS_QUIET_IN_HERE,
  NO_PLANS_CONTACT_ADMIN,
} from 'constants/languageConstants';
import notebookIcon from 'images/icons/notebook.svg';

import styles from './noPlansView.module.less';

type NoPlansViewProps = {
  className?: string;
};

const NoPlansView: FC<NoPlansViewProps> = ({ className }: NoPlansViewProps) => {
  const language = useAppSelector((state) => state.benguide.data?.language);

  return (
    <div className={styles.containedDiv}>
      <div className={`${styles.noPlansWrapper} ${className}`}>
        <Row className={styles.detailWrapper}>
          <img src={notebookIcon} alt="edit" />
        </Row>
        <Row className={styles.header}>
          {getText(ITS_QUIET_IN_HERE, language)}
        </Row>
        <Row className={styles.subHeader}>
          {getText(NO_PLANS_CONTACT_ADMIN, language)}
        </Row>
      </div>
    </div>
  );
};

export default NoPlansView;
